/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { signUpConfirmPostRequestSchema } from './signUpConfirmPostRequestSchema.ts';
import { signUpConfirmPostResponseSchema } from './signUpConfirmPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postSignUpConfirm200Schema = z.lazy(() => signUpConfirmPostResponseSchema);

/**
 * @description 505 response
 */
export const postSignUpConfirm505Schema = z.any();

export const postSignUpConfirmMutationRequestSchema = z.lazy(() => signUpConfirmPostRequestSchema);

export const postSignUpConfirmMutationResponseSchema = z.lazy(() => postSignUpConfirm200Schema);
